import { useEffect } from 'react'

interface ErrorInfo {
  message: string
  stack?: string
  source?: string
  lineno?: number
  colno?: number
  timestamp: number
}

export const useGlobalErrorHandler = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const errorInfo: ErrorInfo = {
        message: event.message,
        stack: event.error?.stack,
        source: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        timestamp: Date.now(),
      }

      console.group('[Global Error Handler]')
      console.error('Error:', errorInfo)
      console.groupEnd()

      // 可以在这里上报到监控服务
      // window.Sentry?.captureException(event.error)
      // reportError(errorInfo)
    }

    const handleRejection = (event: PromiseRejectionEvent) => {
      const errorInfo: ErrorInfo = {
        message: event.reason?.message || String(event.reason),
        stack: event.reason?.stack,
        timestamp: Date.now(),
      }

      console.group('[Unhandled Promise Rejection Handler]')
      console.error('Promise Rejection:', errorInfo)
      console.groupEnd()

      // 可以在这里上报到监控服务
      // window.Sentry?.captureException(event.reason)
      // reportError(errorInfo)
    }

    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', handleRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleRejection)
    }
  }, [])
}
